import CONSTANTS from '@/constants'
import api from './api'

// notification apis
const qrUpload = {
	datatable(params) {
		return api.post(`${CONSTANTS.API_BASE_URL}/api/qr/datatable`, params)
	},
	store(params) {
		return api.post(`${CONSTANTS.API_BASE_URL}/api/qr/save`, params)
	},
	destroy(id) {
		return api.delete(`${CONSTANTS.API_BASE_URL}/api/qr/delete/${id}`)
	},
}
export default qrUpload
